/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-ref-border-color);
  --border-radius: 0;
  --padding: 0;
  --size: var(--nve-ref-border-width-sm);
  width: 100%;
}

[internal-host] {
  display: block;
  width: 100%;
  height: var(--size);
  background-color: var(--color);
  border-radius: var(--border-radius);
  padding: var(--padding);
}

:host([orientation='vertical']) {
  align-self: stretch;
  height: inherit;
  width: var(--size);
}

:host([orientation='vertical']) [internal-host] {
  height: 100%;
  width: var(--size);
}
